import {createActionCreator, createVoidActionCreator} from '../common/actions';
import {FilesOptions} from './reducer';

export const FilesOptionsTriggered = createActionCreator<FilesOptions>('FILES_OPTIONS_TRIGGERED');
export const FilesOptionsClosed = createVoidActionCreator('FILES_OPTIONS_CLOSED');
